export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const CHARITY_SLOTS = [1, 2, 3, 4];

export function parseAmount(val) {
  if (val == null) return null;
  const num = parseFloat(String(val).replace(/[$£€,\s]/g, ""));
  return isNaN(num) ? null : num;
}

export function parseDate(val) {
  if (!val) return null;
  const d = new Date(val);
  return isNaN(d.getTime()) ? null : d;
}

export function detectCurrencySymbol(rows, amountCol) {
  for (const row of rows) {
    const match = String(row[amountCol] ?? "").match(/^([^0-9\s,.\-]+)/);
    if (match) return match[1];
  }
  return "";
}

export function findDateColumn(headers) {
  return headers.find((h) => /period_start_date/i.test(h)) ?? null;
}

export function findAmountColumn(headers, rows) {
  const preferred = headers.find((h) => /total|amount|donation|value/i.test(h));
  if (preferred) return preferred;
  return (
    headers.find((h) => {
      const count = rows.filter((r) => parseAmount(r[h]) !== null).length;
      return count > rows.length * 0.5;
    }) ?? null
  );
}
